// extracted by mini-css-extract-plugin
module.exports = {"cart-item":"Cart_cart-item__3tWir","summary":"Cart_summary__iz-zP","price":"Cart_price__3UblR","amount":"Cart_amount__invqw","actions":"Cart_actions__Q-Bd7"};